export default __webpack_public_path__ + "static/media/thumbnail.3e50ab7a.webp";